function patchSwatchesConstructorOptionNames() {
  if (
    typeof window.SwatchesConstructor === "undefined" ||
    window.SwatchesConstructor.__dyabooOptionNamesPatched
  ) {
    return false;
  }

  window.SwatchesConstructor.prototype.initSwatches = function (variantId) {
    var instance = this;
    var optionNames = [];
    var options = instance.getJsonObject().options || [];

    variantId = variantId;

    for (var index = 0; index < options.length; index += 1) {
      var option = options[index];
      optionNames[index] =
        typeof option === "string"
          ? option
          : Object(option).name || Object(option).public_name || "Opción";
    }

    instance.options_name = optionNames;
    instance.options = getAllOptions(
      instance.getJsonObject().variants,
      instance.show_unavailable_options,
    );

    if (!variantId) {
      variantId = instance.enableHistoryState && getVariantIdUrl();
    }

    instance.createSwatches(variantId);
  };

  window.SwatchesConstructor.__dyabooOptionNamesPatched = true;
  return true;
}

(function waitForSwatchesPatch(attemptsLeft) {
  if (patchSwatchesConstructorOptionNames() || attemptsLeft <= 0) {
    return;
  }

  window.setTimeout(function () {
    waitForSwatchesPatch(attemptsLeft - 1);
  }, 50);
})(120);

document.addEventListener("DOMContentLoaded", function () {
  const cartList = document.querySelector(".pt-cart-list");
  const hasProductPage = Boolean(document.querySelector(".pt-product-single-info"));
  const hasSwatchArea = Boolean(
    document.querySelector(".pt-swatches-container-js, .pt-quickview-swatches-container-js, .options-color"),
  );
  const hasReviewBlocks = Boolean(
    document.querySelector(".resenas-web, #tab_review, #judgeme_product_reviews, #shopify-product-reviews"),
  );
  const messageModalForm = document.querySelector("#modalProductInfo-03 .form-default");
  const cartUpdateCallbacks = [];
  let cartUpdateQueued = false;

  function initProductPerformanceDiagnostics() {
    const productRoot = document.querySelector(".pt-product-single-info");
    if (!productRoot) return;

    const DIAG_PREFIX = "[DYABOO PDP Monitor]";
    const warnedSignals = new Set();
    const mutationWindow = {
      total: 0,
      windowStart: performance.now(),
    };

    function warnOnce(key, message, details) {
      const serializedDetails = details ? JSON.stringify(details) : "";
      const signature = `${key}:${serializedDetails}`;
      if (warnedSignals.has(signature)) return;
      warnedSignals.add(signature);

      if (details) {
        console.warn(`${DIAG_PREFIX} ${message}`, details);
      } else {
        console.warn(`${DIAG_PREFIX} ${message}`);
      }
    }

    function inspectStaticWeight() {
      const mobileSlides = document.querySelectorAll(".pt-mobile-product-slider img").length;
      const desktopThumbs = document.querySelectorAll("#smallGallery [data-zoom-image]").length;
      const reviewWidgets = document.querySelectorAll(
        "#judgeme_product_reviews, #shopify-product-reviews, .jdgm-widget, .jm-review-widget__header-and-body",
      ).length;
      const thirdPartyScripts = Array.from(document.scripts).filter((script) => {
        const src = script.src || "";
        return (
          src.includes("judge.me") ||
          src.includes("restockrocket") ||
          src.includes("addthis") ||
          src.includes("sliderule") ||
          src.includes("shopify.com/extensions")
        );
      }).length;

      if (mobileSlides >= 7) {
        warnOnce("mobile-gallery-weight", "La galería móvil carga muchas imágenes para una PDP.", {
          mobileSlides,
        });
      }

      if (desktopThumbs >= 7) {
        warnOnce("desktop-gallery-weight", "La galería desktop también viene cargada con muchas imágenes.", {
          desktopThumbs,
        });
      }

      if (thirdPartyScripts >= 6) {
        warnOnce("third-party-script-count", "La PDP tiene muchos scripts de terceros activos.", {
          thirdPartyScripts,
          reviewWidgets,
        });
      }
    }

    function inspectResourceWeight() {
      if (
        !window.performance ||
        typeof performance.getEntriesByType !== "function"
      ) {
        return;
      }

      const resourceEntries = performance.getEntriesByType("resource");
      if (!resourceEntries || !resourceEntries.length) return;

      const imageEntries = resourceEntries.filter(
        (entry) => entry.initiatorType === "img",
      );
      const heavyImages = imageEntries.filter((entry) => {
        return (
          /1024x1024|2048x2048|_800x|_1024x1024|_2048x2048/.test(entry.name) &&
          entry.duration > 250
        );
      });

      const slowScripts = resourceEntries.filter((entry) => {
        return (
          entry.initiatorType === "script" &&
          entry.duration > 400 &&
          (
            entry.name.includes("judge.me") ||
            entry.name.includes("sliderule") ||
            entry.name.includes("restockrocket") ||
            entry.name.includes("addthis")
          )
        );
      });

      if (heavyImages.length >= 4) {
        warnOnce("heavy-image-downloads", "La PDP descargó varias imágenes pesadas o lentas.", {
          count: heavyImages.length,
          examples: heavyImages.slice(0, 4).map((entry) => ({
            name: entry.name,
            duration: Math.round(entry.duration),
          })),
        });
      }

      if (slowScripts.length) {
        warnOnce("slow-third-party-scripts", "Hay scripts de terceros lentos durante la carga de la PDP.", {
          scripts: slowScripts.slice(0, 5).map((entry) => ({
            name: entry.name,
            duration: Math.round(entry.duration),
          })),
        });
      }
    }

    function inspectMainThreadLag() {
      if (!window.setTimeout || !window.performance) return;

      let samples = 0;

      function sampleLag() {
        if (samples >= 12) return;
        const startedAt = performance.now();

        window.setTimeout(() => {
          const delay = performance.now() - startedAt;
          if (delay > 250) {
            warnOnce("event-loop-lag", "Se detectó un bloqueo visible del main thread en la PDP.", {
              delay: Math.round(delay),
            });
          }
          samples += 1;
          sampleLag();
        }, 100);
      }

      sampleLag();
    }

    function inspectMutationPressure() {
      const observer = new MutationObserver((mutations) => {
        mutationWindow.total += mutations.length;

        const now = performance.now();
        if (now - mutationWindow.windowStart < 1000) return;

        if (mutationWindow.total > 120) {
          warnOnce("mutation-pressure", "Hay demasiadas mutaciones DOM por segundo en la PDP.", {
            mutationsPerSecond: mutationWindow.total,
          });
        }

        mutationWindow.total = 0;
        mutationWindow.windowStart = now;
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      window.setTimeout(() => observer.disconnect(), 15000);
    }

    function inspectLongTasks() {
      if (
        typeof PerformanceObserver === "undefined" ||
        typeof PerformanceObserver.supportedEntryTypes === "undefined" ||
        PerformanceObserver.supportedEntryTypes.indexOf("longtask") === -1
      ) {
        return;
      }

      const longTaskObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.duration > 180) {
            warnOnce("long-task", "Se detectó una long task que puede congelar la PDP en móvil.", {
              duration: Math.round(entry.duration),
              startTime: Math.round(entry.startTime),
            });
          }
        });
      });

      longTaskObserver.observe({ entryTypes: ["longtask"] });
      window.setTimeout(() => longTaskObserver.disconnect(), 15000);
    }

    inspectStaticWeight();
    inspectMainThreadLag();
    inspectMutationPressure();
    inspectLongTasks();

    window.addEventListener(
      "load",
      () => {
        window.setTimeout(() => inspectResourceWeight(), 1500);
      },
      { once: true },
    );
  }

  function waitForElement(selector, callback, options = {}) {
    const root = options.root || document;
    const timeout = options.timeout || 5000;
    const existing = root.querySelector(selector);

    if (existing) {
      callback(existing);
      return;
    }

    const observer = new MutationObserver(() => {
      const node = root.querySelector(selector);
      if (!node) return;
      observer.disconnect();
      callback(node);
    });

    observer.observe(root === document ? document.body : root, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), timeout);
  }

  function scheduleCartUpdate() {
    if (cartUpdateQueued) return;
    cartUpdateQueued = true;

    requestAnimationFrame(() => {
      cartUpdateQueued = false;
      cartUpdateCallbacks.forEach((callback) => callback());
      document.dispatchEvent(new CustomEvent("dyaboo:cart-updated"));
    });
  }

  function registerCartUpdate(callback) {
    if (typeof callback !== "function") return;
    cartUpdateCallbacks.push(callback);
  }

  if (cartList) {
    const cartObserver = new MutationObserver(() => scheduleCartUpdate());
    cartObserver.observe(cartList, { childList: true, subtree: true });
  }

  // Enfocar automáticamente el campo de búsqueda al presionar el botón
  const searchButton = document.querySelector(".pt-dropdown-toggle");
  const searchInput = document.querySelector(".pt-search-input");

  if (searchButton && searchInput) {
    searchButton.addEventListener("click", function () {
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    });
  }

  // Ocultar botón de WhatsApp en página de venta al por mayor
  if (window.location.pathname.includes("/pages/venta-al-por-mayor")) {
    waitForElement("gty-whatsapp-chat-button", (whatsappButton) => {
      whatsappButton.style.display = "none";
    });
  }

  // Esperar modal y activar redirección
  if (messageModalForm || document.querySelector("#modalProductInfo-03")) {
    waitForElement("#modalProductInfo-03 .form-default", (formDiv) => {
      formDiv.style.cursor = "pointer";

      if (formDiv.dataset.bound) return;

      formDiv.addEventListener("click", function () {
        window.location.href = "https://dyaboo.com/collections/nuevo";
      });

      formDiv.dataset.bound = "true";
    });
  }

  // Ajuste borde gris al color "Blanco"
  const applyWhiteBorder = () => {
    const whiteOptions = document.querySelectorAll(
      'a.options-color[data-tooltip="Blanco"], a.options-color[data-tooltip="blanco"]',
    );
    if (!whiteOptions || whiteOptions.length === 0) return;

    whiteOptions.forEach((option) => {
      if (!option.classList.contains("white-border-applied")) {
        option.style.border = "1px solid #ccc";
        option.style.boxSizing = "border-box";
        option.classList.add("white-border-applied");
      }
    });
  };

  if (hasSwatchArea) {
    applyWhiteBorder();
    const whiteBorderObserver = new MutationObserver(() => applyWhiteBorder());
    whiteBorderObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => whiteBorderObserver.disconnect(), 5000);
  }

  // Se definen desde theme.liquid
  // const ENABLED_FREE_SHIPPING_NOTICE = ...;
  // const FREE_SHIPPING_THRESHOLD = ...;

  if (ENABLED_FREE_SHIPPING_NOTICE) {
    function formatCurrency(amount) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(amount);
    }

    function updateFreeShippingNotice() {
      const totalElement = document.querySelector(".pt-cart-total-price");
      const noticeContainer = document.querySelector(".pt-envio-gratis-msg");

      if (!totalElement || !noticeContainer) {
        return;
      }

      const rawText = totalElement.textContent || "";
      const numericValue = parseInt(rawText.replace(/\D/g, ""), 10);
      if (isNaN(numericValue)) return;

      const percent = Math.min(
        (numericValue / FREE_SHIPPING_THRESHOLD) * 100,
        100,
      );
      const missing = FREE_SHIPPING_THRESHOLD - numericValue;

      let mensaje = "";
      if (numericValue >= FREE_SHIPPING_THRESHOLD) {
        mensaje = "🎁 ¡Felicitaciones! Tu envío será gratis 🎉";
      } else {
        mensaje = `Falta poco, adiciona ${formatCurrency(
          missing,
        )} más para conseguir <strong>¡envío GRATIS!</strong>`;
      }

      noticeContainer.innerHTML = `
        <div class="pt-envio-gratis-text">${mensaje}</div>
        <div class="pt-envio-bar">
          <div class="pt-envio-bar-fill" style="width: ${percent}%;">
            <span class="pt-envio-icon">🚚</span>
          </div>
        </div>
      `;

      // Ajuste posición del camión después de pintar
      const icon = noticeContainer.querySelector(".pt-envio-icon");
      if (icon) {
        icon.style.left = `calc(${percent}% - 10px)`;
      }
    }

    if (cartList) {
      registerCartUpdate(updateFreeShippingNotice);
      updateFreeShippingNotice();
    }
  }

  // === Mensaje dinámico para descuentos por volumen (Dr Volume Discounts) ===
  // Ya viene definido desde el <script> en el head

  if (ENABLED_VOLUME_DISCOUNT_NOTICE) {
    function updateVolumeDiscountNotice() {
      const noticeContainer = document.querySelector(
        ".pt-descuento-volumen-msg",
      );
      const itemElements = document.querySelectorAll(".pt-cart-list .pt-item");

      if (!noticeContainer) {
        return;
      }

      let totalUnidades = 0;
      let validosParaDescuento = true;

      itemElements.forEach((el) => {
        const qtyText = el.querySelector(".pt-quantity");
        if (!qtyText) return;

        const match = qtyText.textContent.match(/\d+/);
        const cantidad = match ? parseInt(match[0], 10) : 1;
        totalUnidades += cantidad;

        const esValido =
          el.getAttribute("data-coleccion") === VOLUME_DISCOUNT_COLLECTION;
        if (!esValido) validosParaDescuento = false;
      });

      if (!validosParaDescuento) {
        noticeContainer.textContent = "";
        return;
      }

      if (totalUnidades < 2) {
        noticeContainer.textContent = VOLUME_MSG_1;
      } else if (totalUnidades === 2) {
        noticeContainer.textContent = VOLUME_MSG_2;
      } else {
        noticeContainer.textContent = VOLUME_MSG_3;
      }
    }

    if (cartList) {
      registerCartUpdate(updateVolumeDiscountNotice);
      updateVolumeDiscountNotice();
    }
  }

  function initProductReviewVisibility() {
    const emptyReviewTexts = [
      "este producto no ha recibido ninguna reseña todavía",
      "este producto no ha recibido ninguna resena todavia",
      "reseñas de clientes este producto no ha recibido ninguna reseña todavía",
      "resenas de clientes este producto no ha recibido ninguna resena todavia",
      "no reviews yet",
      "be the first to review this item",
      "be the first to review",
      "no review has been submitted",
    ];

    function normalizeText(text) {
      return (text || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function containsEmptyReviewMessage(text) {
      const normalized = normalizeText(text);
      return emptyReviewTexts.some((message) => normalized.includes(message));
    }

    function hasActualReviews(container) {
      return Boolean(
        container.querySelector(".jdgm-rev") ||
          container.querySelector(".jm-review-list__item") ||
          container.querySelector(".jm-review") ||
          container.querySelector(".spr-review") ||
          container.querySelector("[data-average-rating]") ||
          container.querySelector(".jdgm-histogram") ||
          container.querySelector(".jdgm-widget-actions-wrapper") ||
          container.querySelector(".jm-star-rating"),
      );
    }

    function hasEmptyReviewState(content) {
      return Boolean(
        content.querySelector(".jm-no-reviews-state") ||
          content.querySelector(".jdgm-empty-state") ||
          containsEmptyReviewMessage(content.textContent),
      );
    }

    function syncReviewBlock(wrapper, content) {
      if (!wrapper || !content) return;

      const shouldHide = !hasActualReviews(content) && hasEmptyReviewState(content);

      wrapper.classList.toggle("dyaboo-reviews-hidden", shouldHide);
    }

    function syncAllReviewBlocks() {
      document.querySelectorAll(".resenas-web").forEach((wrapper) => {
        const content =
          wrapper.querySelector("#judgeme_product_reviews") ||
          wrapper.querySelector(".jm-review-widget__header-and-body") ||
          wrapper.querySelector(".jdgm-widget") ||
          wrapper;
        syncReviewBlock(wrapper, content);
      });

      document.querySelectorAll("#tab_review").forEach((block) => {
        const legacyContent =
          block.querySelector("#shopify-product-reviews") ||
          block.querySelector(".pt-collapse-content") ||
          block;
        syncReviewBlock(block, legacyContent);
      });
    }

    const observer = new MutationObserver(() => syncAllReviewBlocks());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    syncAllReviewBlocks();
  }

  if (hasReviewBlocks) {
    initProductReviewVisibility();
  }

  function initRestockRocketIntegration() {
    const productRoots = document.querySelectorAll(".pt-product-single-info");
    if (!productRoots.length) return;

    const selectors = {
      variantInput: 'input.input_variant[name="id"]',
      variantData: ".dyaboo-variant-availability-json",
      addToCartButton: ".btn-addtocart",
      restockSlot: "[data-restock-rocket-slot]",
      restockContainer: ".restock-rocket-button-container",
      swatches: ".pt-swatches-container-js",
    };

    function parseVariantState(root) {
      const dataNode = root.querySelector(selectors.variantData);
      if (!dataNode) return null;

      try {
        const parsed = JSON.parse(dataNode.textContent);
        parsed.variantMap = new Map(
          (parsed.variants || []).map((variant) => [String(variant.id), variant]),
        );
        return parsed;
      } catch (error) {
        console.warn("[DYABOO Restock Rocket] No se pudo leer el JSON de variantes.", error);
        return null;
      }
    }

    function getRestockElements(root) {
      return {
        slot: root.querySelector(selectors.restockSlot),
        container: root.querySelector(selectors.restockContainer),
      };
    }

    function moveRestockButton(root) {
      const { slot, container } = getRestockElements(root);
      if (!slot || !container || container.parentNode === slot) return;
      slot.appendChild(container);
    }

    function getActiveVariant(root, state) {
      const variantInput = root.querySelector(selectors.variantInput);
      if (!variantInput || !state || !state.variantMap) return null;
      return state.variantMap.get(String(variantInput.value)) || null;
    }

    function emitVariantEvents(root, variant) {
      const variantInput = root.querySelector(selectors.variantInput);
      if (!variantInput || !variant) return;
      const form = variantInput.closest("form");
      const payload = {
        productId: root.dataset.productId || null,
        variant,
      };

      variantInput.value = String(variant.id);
      variantInput.setAttribute("value", String(variant.id));

      variantInput.dispatchEvent(new Event("input", { bubbles: true }));
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));

      if (window.jQuery) {
        const $variantInput = window.jQuery(variantInput);
        const $root = window.jQuery(root);
        const $document = window.jQuery(document);
        const $window = window.jQuery(window);

        $variantInput.trigger("input");
        $variantInput.trigger("change");
        form && window.jQuery(form).trigger("change");
        $root.trigger("variant:change", [payload]);
        $document.trigger("variant:change", [payload]);
        $document.trigger("product:variant-change", [payload]);
        $document.trigger("theme:variant:change", [payload]);
        $window.trigger("theme:variant:change", [payload]);
      }

      document.dispatchEvent(new CustomEvent("variant:change", { detail: payload }));
      document.dispatchEvent(new CustomEvent("product:variant-change", { detail: payload }));
      document.dispatchEvent(new CustomEvent("theme:variant:change", { detail: payload }));
      window.dispatchEvent(new CustomEvent("theme:variant:change", { detail: payload }));
    }

    function updateVisualState(root, variant) {
      const addToCartButton = root.querySelector(selectors.addToCartButton);
      const addToCartColumn = addToCartButton ? addToCartButton.closest(".col-item") : null;
      const { slot, container } = getRestockElements(root);
      const isAvailable = !variant || Boolean(variant.available);

      moveRestockButton(root);

      if (addToCartColumn) {
        addToCartColumn.style.display = isAvailable ? "" : "none";
      } else if (addToCartButton) {
        addToCartButton.style.display = isAvailable ? "" : "none";
      }

      if (slot) {
        slot.style.display = isAvailable ? "none" : "block";
      }

      if (container) {
        container.style.display = isAvailable ? "none" : "block";
      }
    }

    function syncRoot(root, variantOverride) {
      const state = root._dyabooRestockRocketState || parseVariantState(root);
      if (!state) return;

      root._dyabooRestockRocketState = state;
      root.dataset.productId = String(state.productId || "");

      const variant = variantOverride || getActiveVariant(root, state);
      if (!variant) return;

      const variantId = String(variant.id);
      if (root.dataset.activeVariantId !== variantId) {
        root.dataset.activeVariantId = variantId;
        emitVariantEvents(root, variant);
      }

      updateVisualState(root, variant);
    }

    window.DyabooRestockRocket = window.DyabooRestockRocket || {};
    window.DyabooRestockRocket.syncProductPageVariant = function (root, variant) {
      if (!root) return;
      syncRoot(root, variant || null);
    };

    productRoots.forEach((root) => {
      const variantInput = root.querySelector(selectors.variantInput);
      if (!variantInput) return;

      const swatches = root.querySelector(selectors.swatches);
      const appObserver = new MutationObserver(() => syncRoot(root));
      appObserver.observe(root, { childList: true, subtree: true });

      const inputObserver = new MutationObserver(() => syncRoot(root));
      inputObserver.observe(variantInput, {
        attributes: true,
        attributeFilter: ["value"],
      });

      variantInput.addEventListener("change", () => syncRoot(root));

      if (swatches) {
        swatches.addEventListener("click", () => {
          requestAnimationFrame(() => syncRoot(root));
        });
        swatches.addEventListener("change", () => syncRoot(root));
      }

      syncRoot(root);
    });
  }

  if (hasProductPage) {
    initProductPerformanceDiagnostics();
    initRestockRocketIntegration();
  }
});



